import React, { useCallback, useLayoutEffect, useRef } from 'react';
import { useMount } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';

import { heightChanged as wizardHeightChanged } from '../../../../common/store/wizard';
import { useMobile } from '../../../../common/components/responsive/Responsive';
import SearchResults from '../../../../common/components/search-results/SearchResults';
import AddPlaceControl from '../../../../common/components/add-place-control/AddPlaceControl';
import { activeItemChanged } from '../../../item-details/store';
import {
  clearFormState,
  clearLastSentEditMetadata,
  clearRoutablePoints,
  longPressLocationChanged,
  selectLongPressLocation,
} from '../../../../common/store/item-edit';
import Overlay from '../../../../common/components/overlay/Overlay';
import AddPlaceCategories from '../../../../common/components/add-place-categories/AddPlaceCategories';

const RootPage = () => {
  const isMobile = useMobile();
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(activeItemChanged({ item: null }));
    dispatch(clearFormState());
    dispatch(clearRoutablePoints());
    dispatch(wizardHeightChanged(null));
    dispatch(clearLastSentEditMetadata());
    dispatch(longPressLocationChanged(null));
  });

  const longPressLocation = useSelector(selectLongPressLocation);
  const handleLongPressAdditionCategoriesClose = useCallback(
    () => dispatch(longPressLocationChanged(null)),
    [dispatch],
  );

  const addPlaceCategoriesRef = useRef<HTMLElement>();
  useLayoutEffect(() => {
    dispatch(
      wizardHeightChanged(
        longPressLocation && addPlaceCategoriesRef.current
          ? addPlaceCategoriesRef.current.offsetHeight + 16
          : null,
      ),
    );
  }, [longPressLocation, dispatch]);

  return (
    <>
      <SearchResults
        className="wizard__search-results"
        showAddPlaceWhen="empty"
        showIndexes={!isMobile}
      />
      {(!longPressLocation || !isMobile) && (
        <AddPlaceControl className="wizard__add-place-control" />
      )}
      {longPressLocation && (
        <Overlay className="wizard__long-press-add-overlay" position="bottom">
          <AddPlaceCategories
            ref={addPlaceCategoriesRef}
            className="wizard__long-press-add-categories"
            onCloseButtonClick={handleLongPressAdditionCategoriesClose}
          />
        </Overlay>
      )}
    </>
  );
};

export default RootPage;
